import { regexSplitByDash } from 'constants/knowledgeMap';
import { 
  getDecimalValueFromTitlePrefix, 
} from 'builder/Knowledge/helpers/generatePrefix';

/**
 * @param {Object} knowledgeMap 
 * @returns {Object} knowledgeMap with updated title and titleKey
 */
export const updateKnowledgeMapItemTitle = (knowledgeMap) => {
  const { items: knowledgeMapItems } = knowledgeMap;
  const updatedKnowledgeMapItems = Object.keys(knowledgeMapItems).reduce(( updatedKnowledgeMapItem, itemKey) => {
    const {
      abbreviatedStatement,
    } = knowledgeMapItems[itemKey];

    const [
      updatedTitleKey,
      updatedAbbreviatedStatement,
    ] = abbreviatedStatement.split(regexSplitByDash);

    updatedKnowledgeMapItem.push({ 
      titleKey: updatedTitleKey,
      prefixDecimal: getDecimalValueFromTitlePrefix(updatedTitleKey),
      ...knowledgeMapItems[itemKey], 
      abbreviatedStatement: updatedAbbreviatedStatement,
    });
    return updatedKnowledgeMapItem;
  },[]);
  knowledgeMap.items = updatedKnowledgeMapItems;
  return knowledgeMap;
};